import { render, staticRenderFns } from "./Storetable.vue?vue&type=template&id=623b1bc9&scoped=true"
import script from "./Storetable.vue?vue&type=script&lang=js"
export * from "./Storetable.vue?vue&type=script&lang=js"
import style0 from "./Storetable.vue?vue&type=style&index=0&id=623b1bc9&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b1bc9",
  null
  
)

export default component.exports